import type { ComponentType } from 'react';

type CalculatorBySlugComponent = ComponentType<{ slug: string | null }>;

export function loadCalculatorBySlug(): Promise<CalculatorBySlugComponent> {
  return import('@repo/ui/BankingCalculators/CalculatorBySlug').then(
    module => module.CalculatorBySlug,
  );
}
